export default __webpack_public_path__ + "static/media/decada-2010-0003-min.5794fb5d.jpg";